import React, { ReactNode } from "react";

export const QuickConnectContext = React.createContext<
  | {
      closeDrawer: () => void;
      isLoading: boolean;
      tryAgainLoading: boolean;
      quickConnectLoading: boolean;
      onBackToSelectExchange: () => void;
      noFuturesAccountMessageData: {
        show?: boolean;
        errorMessage: string;
        displayMessage: ReactNode;
        onSubmit?: () => void;
        loading: boolean;
      };
      quickConnectAlreadyUsedMessageData: {
        show?: boolean;
        errorMessage: string;
        displayMessage: ReactNode;
        onSubmit?: () => void;
        loading: boolean;
        apiManagementLink?: string;
      };
      isInitialized: boolean;
      quickConnectSucceeded: boolean;
      code?: string | null;
      state?: string | null;
      startAccountsPolling?: () => void;
    }
  | undefined
>(undefined);
